import React from "react";
import { Icon } from "semantic-ui-react";
import "./Badge.css";

const Badge = ({
    children,
    color = "blue",
    size = "medium",
    content,
    className = "",
    icon,
    ...props
}) => {
    const badgeContent = content || children;

    return (
        <span
            className={`custom-badge ${color} ${size} ${className}`}
            {...props}
        >
            {icon && <Icon name={icon} />}
            {badgeContent}
        </span>
    );
};

export default Badge; 